import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  FormGroup,
  Input,
} from "reactstrap";
import { form_validate, notifica } from "../requests/utils";
import { postSaveVistas, getElementos } from "../requests/req-system";

const model_dto = {
  idVista: null,
  idElemento: null,
  codigoVista: null,
  descripcion: null,
  descripcionCorta: null,
  descripcionMenu: null,
  descripcionToolTip: null,
  idEstatus: null,
  img: null,
};

const model_required = {
  codigoVista: {
    message: "Ingresa el codigo de la vista",
  },
  descripcion: {
    message: "Ingresa la descripción de la vista",
  },
  descripcionMenu: {
    message: "Ingresa como quieres que se muestre en el menu del sistema",
  },
  descripcionToolTip: {
    message: "Ingresa el tooltip que se mostrara en el menu",
  },
  idElemento: {
    message: "Selecciona el elemento al que te pertenecera la vista",
  },
};

const ModalVistas = (props) => {
  const {
    className,
    visible,
    onClosed,
    isaddChild,
    data,
    isEdit,
    isPadre,
    onSucces,
    isEditChild,
  } = props;
  const [values, setValues] = useState({ ...model_dto });
  const [title, setTitle] = useState("");
  const [elementos, setElementos] = useState([]);
  useEffect(() => {
    let unmonnted = false;
    if (!unmonnted) {
      if (isEdit) {
        const newValues = { ...values };
        Object.keys(values).forEach((item) => {
          newValues[item] = data[item] ? data[item] : null;
        });
        setValues(newValues);
      }
      if (isaddChild) {
        setTitle(`Agregar sub menu a "${data.descripcion}"`);
      } else if (isEdit) {
        setTitle(`Editar vista "${data.descripcion}"`);
      } else if (isPadre) {
        setTitle("Agregar nueva vista padre");
      }
      setElemetnos_();
    }

    return () => {
      unmonnted = true;
    };
  }, [props]);

  const toggle = () => {
    onClosed();
    setValues(model_dto);
  };

  const setElemetnos_ = async () => {
    let respose = await getElementos();
    setElementos(respose.data);
  };

  const setFieldValues = (field, value) => {
    const newValues = { ...values };
    newValues[field] = value;
    setValues(newValues);
  };

  const onSubmit = async () => {
    let valid_ = form_validate(values, model_required);
    if (valid_.valid) {
      if (isaddChild) {
        values.vistaPadre = data.idVista;
      }
      let res_api = await postSaveVistas(values);
      if (res_api) {
        if (res_api.code === 0) {
          notifica(
            "success",
            "Los cambios se guardaron correctamente",
            "!Alerta"
          );
          onSucces();
          toggle();
        } else {
          notifica("error", res_api.message, "Error");
        }
      }
    } else {
      notifica("error", valid_.message, "Error");
    }
  };

  return (
    <div>
      <Modal isOpen={visible} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle} style={{ fontWeight: "bold" }}>
          {title}
        </ModalHeader>
        <ModalBody>
          <form enctype="multipart/form-data">
            <FormGroup row>
              <Col sm={6} md={6} lg={12}>
                <label>Codigo:</label> <br></br>
                <input
                  type="text"
                  className="inp_large"
                  value={values.codigoVista}
                  onChange={(e) =>
                    setFieldValues("codigoVista", e.target.value)
                  }
                  placeholder="Ingrese el codigo"
                />
              </Col>
              <Col sm={12} md={12} lg={12}>
                <label>Descripción:</label>
                <br></br>
                <input
                  type="text"
                  className="inp_large"
                  value={values.descripcion}
                  onChange={(e) =>
                    setFieldValues("descripcion", e.target.value)
                  }
                  placeholder="Ingrese el nombre de la vista"
                />
              </Col>
              <Col sm={12} md={12} lg={12}>
                <label>Descripción menu:</label>
                <br></br>
                <input
                  type="text"
                  className="inp_large"
                  value={values.descripcionMenu}
                  onChange={(e) =>
                    setFieldValues("descripcionMenu", e.target.value)
                  }
                  placeholder="Ingrese una descripción de la vista"
                />
              </Col>
              <Col sm={12} md={12} lg={12}>
                <label>ToolTip:</label>
                <br></br>
                <input
                  type="text"
                  className="inp_large"
                  value={values.descripcionToolTip}
                  onChange={(e) =>
                    setFieldValues("descripcionToolTip", e.target.value)
                  }
                  placeholder="Ingrese un tooltip"
                />
              </Col>
              {isPadre || (isEditChild === false && isaddChild === false) ? (
                <Col sm={12} md={12} lg={12}>
                  <label>Elemento donde se mostrara:</label>
                  <Input
                    type="select"
                    onChange={(e) => {
                      setFieldValues("idElemento", e.target.value);
                    }}
                    value={values.idElemento}
                  >
                    <option value="">Selecciona una opción</option>

                    {elementos
                      ? elementos.map((item) => (
                          <option value={item.idElemento}>{item.nombre}</option>
                        ))
                      : null}
                  </Input>
                </Col>
              ) : null}
              {values.idVista !== undefined && values.idVista !== null ? (
                <Col sm={6} md={6} lg={12}>
                  <label>{values.idEstatus ? "Desactivar" : "Activar"}:</label>{" "}
                  <br></br>
                  <div className="ckF_disable">
                    <input
                      type="checkbox"
                      id={`check_`}
                      checked={values.idEstatus}
                      onClick={(e) => {
                        setFieldValues("idEstatus", !values.idEstatus);
                      }}
                    />
                    <label htmlFor={`check_`}>
                      <span></span>
                    </label>
                  </div>
                </Col>
              ) : null}
              <Col lg="12" sm="12" md="12">
                <label>Imagen:</label>
                <br></br>
                <input
                  type="file"
                  className="inp_large"
                  onChange={(e) => {
                    setFieldValues("img", e.target.files[0]);
                  }}
                  placeholder="Ingrese o busque la imagen"
                />
              </Col>
            </FormGroup>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => onSubmit()}>
            GUARDAR
          </Button>
          <Button color="secondary" onClick={toggle}>
            CANCELAR
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalVistas;
